var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.deviceTypeCode)?_c('protocolList',{attrs:{"isHideKeyword":true,"hideKeyword":'办公区',"deviceTypeCode":_vm.deviceTypeCode}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }